import { http } from '../../../../api/http';
import type { ReciboHonorarios } from '../types/honorarios';

const ENDPOINT = '/planilla/recibo-honorarios';

export class HonorariosService {
  static async getAll(): Promise<ReciboHonorarios[]> {
    const response = await http.get(ENDPOINT);
    return response.data;
  }

  static async save(recibo: ReciboHonorarios): Promise<ReciboHonorarios> {
    const response = await http.post(ENDPOINT, recibo);
    return response.data;
  }

  static async delete(id: number): Promise<void> {
    await http.delete(`${ENDPOINT}/${id}`);
  }
}
